import { Theme, makeStyles } from '@lifeomic/chroma-react/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '1rem',
    flex: '0 0 100%',
  },
  labelText: {
    color: theme.palette.text.secondary,
  },
  errorLabel: {
    color: theme.palette.error.main,
  },
  errorText: {
    marginTop: theme.spacing(1),
    color: theme.palette.error.main,
  },
  obviousLink: {
    textDecoration: 'underline',
  },
  addNewFinding: {
    marginTop: theme.spacing(1),
  },
  recommendationAndNotes: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}));

export default useStyles;
